export default "__VITE_ASSET__hwJw77I7__"